<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let min = 32;
  export let max = 100;
  export let step = 1;
  export let value = 32;

  const dispatch = createEventDispatcher<{valueChange: number}>();
  const sendValue = () => {
    dispatch('valueChange', value);
  }

</script>

<div class="range-control">
  <div class="range-control__label range-control__label--left">{min}</div>
  <div class="range-control__range-container">
    <label for=minPow class="form-label">
      <slot></slot> {value}
    </label>
    <input type=range  class="form-range" id=minPow
           {min} {max} {step}
           bind:value={value}
           on:change={sendValue}
           on:input={sendValue}>
  </div>
  <div class="range-control__label range-control__label--right">{max}</div>
</div>
